import axios from 'axios'
import jsonp from 'jsonp'
const driveUrl = ''
// 携带cookie
axios.defaults.withCredentials = true

const dealErrors = (e, cb) => {
  if (!e || !cb) {
    return
  }
  let err = {
    status: 500,
    data: {
      result: 'errInter'
    }
  }
  console.log(e)
  let res = e.response && typeof e.response.data == 'object' ? e.response : err
  res.data.result === 'userNotLogin' && !window.cefQuery ? location.href = `https://drive.wps.com/welcome?cb=${encodeURIComponent(location.href)}` : ''
  
  typeof res === 'object'  ? cb(res) : cb(err)
}
export const $axios = axios
let requests = []

function checkIn(method,url){
  let idx = requests.indexOf(`${method}:${url}`)
  if (idx > -1) {
    return true
  }else{
    requests.push(`${method}:${url}`)
    setTimeout(() => {
      let idx = requests.indexOf(`${method}:${url}`)
      requests.splice(idx,1)
    }, 300);
    return false
  }
}
export const getData = (url, cf, cb) => {
  if (checkIn('GET', url)) {
    return
  }
  return axios.get(`${driveUrl}${url}`, cf || {}).then(cb).catch(e => {
    dealErrors(e, cb)
  })
}
export const postData = (url, data, cf, cb) => {
  if (checkIn('POST', url)) {
    return
  }
  return axios.post(`${driveUrl}${url}`, data || {}, cf || {}).then(cb).catch(e => {
    dealErrors(e, cb)
  })
}
export const putData = (url, data, cf, cb) => {
  if (checkIn('PUT', url)) {
    return
  }
  return axios.put(`${driveUrl}${url}`, data || {}, cf || {}).then(cb).catch(e => {
    dealErrors(e, cb)
  })
}

export const deleteData = (url, data, cf, cb) => {
  if (checkIn('DELETE', url)) {
    return
  }
  return axios.delete(`${driveUrl}${url}`, {
    data,
    ...cf
  }).then(cb).catch(e => {
    dealErrors(e, cb)
  })
}

export const jsonpData = (url, cf, cb) => {
  if (checkIn('JSP', url)) {
    return
  }
  return jsonp(url, cf, (err, data) => {
    err ? cb() : cb(data)
  })
}


// WEBPACK FOOTER //
// ./src/store/service/request.js